import {Dimensions, StyleSheet} from 'react-native';

import {cloud, cloudLight, white} from '/theme/color/on.color';
import {codGray, denim, pearl} from '/theme/color/secondary.color';

const {height} = Dimensions.get('window');

export const styles = StyleSheet.create({
  modal: {
    margin: 0,
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
  },
  modalView: {
    width: 500,
    height: height,
    backgroundColor: white,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  scrollView: {
    flex: 1,
  },
  scrollContent: {
    paddingBottom: 120,
  },
  scrollContentKeyboard: {
    paddingBottom: 220,
  },
  modalHeader: {
    flexDirection: 'row',
    paddingHorizontal: 10,
    paddingBottom: 10,
    paddingTop: 4,
    marginTop: 0,
  },
  headerText: {
    fontSize: 16,
    marginLeft: 10,
  },
  closeIcon: {
    fontSize: 24,
  },
  filterIcon: {
    fontSize: 20,
    color: codGray,
    marginLeft: 'auto',
  },
  fixedButtonContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 12,
    paddingTop: 6,
    backgroundColor: white,
    borderTopWidth: 1,
    borderTopColor: cloudLight,
  },
  clearButton: {
    borderWidth: 1,
    borderColor: cloud,
    borderRadius: 6,
    paddingVertical: 9,
    paddingHorizontal: 20,
    backgroundColor: white,
  },
  clearText: {
    color: codGray,
  },
  applyButton: {
    backgroundColor: denim,
    borderRadius: 6,
    paddingVertical: 9,
    paddingHorizontal: 20,
  },
  applyText: {
    color: white,
  },
  radioButtonsContainer: {
    flexDirection: 'column',
    marginHorizontal: 20,
  },
  filterSection: {
    marginVertical: 10,
  },
  sectionTitle: {
    fontSize: 14,
    marginVertical: 10,
  },
  radioOptionRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 8,
  },
  radioOptionIcon: {
    height: 20,
    width: 20,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: codGray,
    justifyContent: 'center',
  },
  radioOptionIconSelected: {
    height: 20,
    width: 20,
    borderRadius: 10,
    borderWidth: 5,
    borderColor: denim,
    backgroundColor: pearl,
    justifyContent: 'center',
  },
  radioOptionLabel: {
    fontSize: 16,
    marginLeft: 16,
    color: codGray,
  },
  radioOptionLabelSelected: {
    fontSize: 16,
    marginLeft: 16,
  },
  checkboxItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 10,
    paddingLeft: 0,
  },
  checkboxIcon: {
    fontSize: 20,
    borderRadius: 2,
    color: pearl,
    backgroundColor: codGray,
    marginRight: 12,
  },
  checkboxIconSelected: {
    fontSize: 20,
    color: denim,
    borderRadius: 2,
    backgroundColor: 'transparent',
    marginRight: 12,
  },
  checkboxLabel: {
    fontSize: 15,
    color: codGray,
    flex: 1,
    flexShrink: 1,
    minWidth: 0,
    flexWrap: 'wrap',
  },
});

export const createStyles = () => ({
  ...styles,
  keyboardAvoidingView: {
    flex: 1,
  },
  sheet: styles.modalView,
  innerContainer: {
    flex: 1,
    flexDirection: 'column' as const,
  },
});
